const abi = [
    {
        inputs: [{ internalType: 'address', name: 'module', type: 'address' }],
        name: 'isModuleEnabled',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
];
export default abi;
//# sourceMappingURL=GnosisSafeL2Proxy.js.map